import { LobbyImage } from '@colonist/types';
import { NotificationTypeEnum } from '../../../../shared/NotificationTypes.ts';
import { UINotificationItemViewBase } from './UINotificationItemViewBase.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { UIUtilsNotifications } from './UIUtilsNotifications.ts';
import { getNestedTranslation } from '@colonist/i18n';
import { StoreItemController } from '../../../../shared/store/StoreItemController.ts';
export class UINotificationItemView extends UINotificationItemViewBase {
    setOnClose(callback) {
        this.setOnClose = callback;
    }
    getViewData(notificationTypeData, notificationUserDetails) {
        switch(notificationTypeData.type){
            case NotificationTypeEnum.UserReportedBanned:
                return {
                    text: {
                        key: 'strings:popups.notification.reportedUserBanned.body'
                    },
                    image: LobbyImage.Guest
                };
            case NotificationTypeEnum.UserReportedThankYou:
                return {
                    text: {
                        key: 'strings:popups.notification.reportedUserThankYou.body'
                    },
                    image: LobbyImage.Guest
                };
            case NotificationTypeEnum.HolidaySale2023Expired:
                return {
                    text: {
                        key: 'strings:popups.notification.holidaySale2023Expired.body'
                    },
                    clickAction: ()=>{
                        var _this_onClose, _this;
                        return (_this_onClose = (_this = this).onClose) === null || _this_onClose === void 0 ? void 0 : _this_onClose.call(_this);
                    },
                    image: LobbyImage.Guest,
                    secondaryLink: {
                        url: '/store',
                        openNewTab: true,
                        text: {
                            key: 'strings:popups.notification.giftMembershipReceived.checkButton',
                            options: {
                                context: UIUtilsEjsVariables.isUserOnDiscord ? 'discord' : ''
                            }
                        }
                    }
                };
            case NotificationTypeEnum.GiftMembershipReceivedFromAdmin:
                return {
                    text: {
                        key: 'strings:popups.notification.giftMembershipReceived.body'
                    },
                    clickAction: ()=>{
                        var _this_onClose, _this;
                        return (_this_onClose = (_this = this).onClose) === null || _this_onClose === void 0 ? void 0 : _this_onClose.call(_this);
                    },
                    image: LobbyImage.Guest,
                    secondaryLink: {
                        url: '/store#gifted_memberships',
                        openNewTab: true,
                        text: {
                            key: 'strings:popups.notification.giftMembershipReceived.checkButton',
                            options: {
                                context: UIUtilsEjsVariables.isUserOnDiscord ? 'discord' : ''
                            }
                        }
                    }
                };
            case NotificationTypeEnum.TranslationHelp:
                return {
                    text: {
                        key: 'strings:popups.notification.translationHelp.body',
                        options: {
                            language: notificationTypeData.language,
                            username: notificationTypeData.username,
                            link: UIUtilsEjsVariables.isUserOnMobileAppOrWeb ? undefined : notificationTypeData.link
                        }
                    },
                    image: LobbyImage.Guest
                };
            case NotificationTypeEnum.UserReportedWarning:
                return {
                    text: {
                        key: 'strings:popups.notification.reportedUserWarning'
                    },
                    image: LobbyImage.DangerIcon
                };
            case NotificationTypeEnum.RoomInviteResponse:
                var _notificationUserDetails_icon;
                return {
                    text: {
                        key: 'strings:popups.notification.youRespondedToRoomInviteFrom',
                        options: {
                            username: notificationUserDetails === null || notificationUserDetails === void 0 ? void 0 : notificationUserDetails.username,
                            context: notificationTypeData.response ? undefined : 'declined'
                        }
                    },
                    image: (_notificationUserDetails_icon = notificationUserDetails === null || notificationUserDetails === void 0 ? void 0 : notificationUserDetails.icon) !== null && _notificationUserDetails_icon !== void 0 ? _notificationUserDetails_icon : LobbyImage.Guest
                };
            case NotificationTypeEnum.MissedRoomInvite:
                var _notificationUserDetails_icon1;
                return {
                    text: {
                        key: 'strings:popups.notification.youRespondedToRoomInviteFrom',
                        options: {
                            username: notificationUserDetails === null || notificationUserDetails === void 0 ? void 0 : notificationUserDetails.username,
                            context: 'missed'
                        }
                    },
                    image: (_notificationUserDetails_icon1 = notificationUserDetails === null || notificationUserDetails === void 0 ? void 0 : notificationUserDetails.icon) !== null && _notificationUserDetails_icon1 !== void 0 ? _notificationUserDetails_icon1 : LobbyImage.Guest
                };
            case NotificationTypeEnum.YouAreNowFriendsWith:
                var _notificationUserDetails_icon2;
                return {
                    text: {
                        key: 'strings:popups.notification.youAreNowFriendsWith',
                        options: {
                            username: notificationUserDetails === null || notificationUserDetails === void 0 ? void 0 : notificationUserDetails.username
                        }
                    },
                    image: (_notificationUserDetails_icon2 = notificationUserDetails === null || notificationUserDetails === void 0 ? void 0 : notificationUserDetails.icon) !== null && _notificationUserDetails_icon2 !== void 0 ? _notificationUserDetails_icon2 : LobbyImage.Guest
                };
            case NotificationTypeEnum.GiftMembershipReceivedFromUser:
                var _notificationTypeData_giftMessage;
                const giftMessage = notificationTypeData === null || notificationTypeData === void 0 ? void 0 : (_notificationTypeData_giftMessage = notificationTypeData.giftMessage) === null || _notificationTypeData_giftMessage === void 0 ? void 0 : _notificationTypeData_giftMessage.trim();
                var _notificationUserDetails_icon3;
                return {
                    text: {
                        key: 'strings:popups.notification.giftMembershipReceivedFromFriend',
                        options: {
                            context: giftMessage ? '' : 'noMessage',
                            gifter: notificationUserDetails === null || notificationUserDetails === void 0 ? void 0 : notificationUserDetails.username,
                            giftMessage: giftMessage
                        }
                    },
                    image: (_notificationUserDetails_icon3 = notificationUserDetails === null || notificationUserDetails === void 0 ? void 0 : notificationUserDetails.icon) !== null && _notificationUserDetails_icon3 !== void 0 ? _notificationUserDetails_icon3 : LobbyImage.Guest
                };
            case NotificationTypeEnum.GiftMembershipWasSent:
                const membershipTier = UIUtilsNotifications.getMembershipTitleFromType(notificationTypeData.membershipType);
                var _notificationUserDetails_icon4;
                return {
                    text: getNestedTranslation({
                        key: 'strings:popups.notification.giftMembershipWasSentToFriend',
                        options: {
                            duration: notificationTypeData.duration,
                            username: notificationUserDetails === null || notificationUserDetails === void 0 ? void 0 : notificationUserDetails.username
                        }
                    }, {
                        membershipType: membershipTier
                    }),
                    image: (_notificationUserDetails_icon4 = notificationUserDetails === null || notificationUserDetails === void 0 ? void 0 : notificationUserDetails.icon) !== null && _notificationUserDetails_icon4 !== void 0 ? _notificationUserDetails_icon4 : LobbyImage.Guest
                };
            case NotificationTypeEnum.GiftURLCreated:
                const key = 'strings:popups.notification.giftURLCreated';
                const context = notificationTypeData.duration == 1 ? '' : 'multiple';
                const membershipType = UIUtilsNotifications.getMembershipTitleFromType(notificationTypeData.membershipType);
                var _notificationUserDetails_icon5;
                return {
                    text: getNestedTranslation({
                        key: key,
                        options: {
                            duration: notificationTypeData.duration,
                            hash: notificationTypeData.hash,
                            context: context
                        }
                    }, {
                        membershipType: membershipType
                    }),
                    image: (_notificationUserDetails_icon5 = notificationUserDetails === null || notificationUserDetails === void 0 ? void 0 : notificationUserDetails.icon) !== null && _notificationUserDetails_icon5 !== void 0 ? _notificationUserDetails_icon5 : LobbyImage.Guest
                };
            case NotificationTypeEnum.ReferralRewardItemUnlocked:
                const item = StoreItemController.getItemDetailForReferralProgram(notificationTypeData.itemCategory, notificationTypeData.itemType);
                if (item == undefined) throw new Error('Item does not exist');
                return {
                    text: getNestedTranslation({
                        key: 'strings:popups.notification.referralRewardItemUnlocked.body',
                        options: {
                            itemName: item.name,
                            referralCount: notificationTypeData.referralCount,
                            context: notificationTypeData.referralCount == 1 ? 'one' : 'other'
                        }
                    }, {
                        itemName: item.name
                    }),
                    image: item.image,
                    secondaryLink: {
                        url: '/store#referrals',
                        openNewTab: true,
                        text: {
                            key: 'strings:popups.notification.referralRewardItemUnlocked.checkButton'
                        }
                    }
                };
            case NotificationTypeEnum.NewUserJoinedFromReferral:
                return {
                    text: {
                        key: 'strings:popups.notification.newUserJoinedFromReferral.body',
                        options: {
                            referralLeftCount: notificationTypeData.referralLeftCount,
                            username: notificationTypeData.username,
                            context: notificationTypeData.referralLeftCount == 1 ? 'one' : 'other'
                        }
                    },
                    image: LobbyImage.StoreGiftMembership,
                    secondaryLink: {
                        url: '/store#referrals',
                        openNewTab: true,
                        text: {
                            key: 'strings:popups.notification.newUserJoinedFromReferral.checkButton'
                        }
                    }
                };
            case NotificationTypeEnum.YouAreBanned:
                const bannedUntil = new Date(notificationTypeData.untilDate).toDateString();
                const message = {
                    key: 'strings:popups.errors.userBannedError.youAreBanned',
                    options: {
                        untilDate: ` until ${bannedUntil}`
                    }
                };
                return {
                    text: message,
                    image: LobbyImage.DangerIcon
                };
            case NotificationTypeEnum.GeneralAnnouncement:
                return {
                    text: {
                        key: 'strings:colonistCommon.utils.#buffer',
                        options: {
                            value: notificationTypeData.message
                        }
                    },
                    image: LobbyImage.GameModeBase
                };
            case NotificationTypeEnum.YourFriendMustLogInToCountReferral:
                return {
                    text: {
                        key: 'strings:popups.notification.yourFriendMustLogInToCountReferral.body',
                        options: {
                            username: notificationTypeData.username
                        }
                    },
                    image: LobbyImage.Guest
                };
            case NotificationTypeEnum.YouAreMuted:
                return {
                    text: {
                        key: 'strings:popups.notification.youAreMuted.body'
                    },
                    image: LobbyImage.DangerIcon
                };
        }
    }
    constructor(notificationData, parentContainer){
        super(notificationData.id, notificationData.dateReceived, parentContainer);
        this.notificationUserDetails = notificationData.notificationUserDetails;
        this.viewData = this.getViewData(notificationData.typeData, this.notificationUserDetails);
        this.createBaseNotification(notificationData.dateReceived);
        this.showUnreadIconIfNeeded(notificationData.dateRead);
        this.setClickActions();
        this.removeContentHoverEffectIfNoClickAction();
    }
}
